
import createjs from 'createjs-module'

import { Dimensions } from '../../../../../globals/Dimensions';
import { SpotSelectedLayer } from './SpotSelectedLayer';

import { StrokedText } from '../../../../../com/canvas/strotedText/StrokedText'
import { Spots } from '../Spots';
import {FlyerPageSpotDto, FrameIconDataDto} from '../../../../../dtos';

import { Boundries } from '../../../../../globals/Boundries'

import bottom_left_to_top_right_scaller from '../../../../../assets/editors/spots/bottom_left_to_top_right_scaller.svg'
import top_left_to_bottom_right_scaller from '../../../../../assets/editors/spots/top_left_to_bottom_right_scaller.svg'
import promoIcon from '../../../../../assets/iconStyles/set_1/set_1_Promo.svg'
import promoJumpToPageIcon from '../../../../../assets/iconStyles/set_1/set_1_Page.svg'
import promoJumpToUrlIcon from '../../../../../assets/iconStyles/set_1/set_1_Link.svg'
import promoPlayVideoIcon from '../../../../../assets/iconStyles/set_1/set_1_Video.svg'
import promoImageIcon from '../../../../../assets/iconStyles/set_1/set_1_Image.svg'
import promoImage360Icon from '../../../../../assets/iconStyles/set_1/set_1_360.svg'

import {
    EVENT_DATA_TYPE_SPOT_DRAG_TOP_LEFT,
    EVENT_DATA_TYPE_SPOT_DRAG_TOP_RIGHT,
    EVENT_DATA_TYPE_SPOT_DRAG_BOTTOM_LEFT,
    EVENT_DATA_TYPE_SPOT_DRAG_BOTTOM_RIGHT,
    EVENT_DATA_TYPE_SPOT_PRESS_MOVE,

    dispatchEventDataType,
} from '../../../../../globals/EventDispatcher'

import { GlobalIdGenerator } from '../../../../../globals/GlobalIdGenerator'

export class Spot extends createjs.Container {

    private _originalX:number = 0;
    private _originalY:number = 0;
    public _originalWidth: number = 0;
    public _originalHeight: number = 0;
    private _background: createjs.Shape | null = null;
    private _frameIcon: createjs.Bitmap | null = null;
    public _frameIconData: FrameIconDataDto | null = null;
    public _label: StrokedText | null = null;
    private _isSelected: boolean = false;
    private _selectedLayer: SpotSelectedLayer | null = null;
    public _input: HTMLInputElement | null = null;
    private _canvasInput: createjs.DOMElement | null = null;
    private _globalId: string | null = null;
    private _hasNumber: boolean = false;
    private _mainContainer: Spots | null = null;
    public _data: FlyerPageSpotDto | null = null;

    constructor(mainContainer: Spots) {
        super()

        let golbalId = this._globalId = GlobalIdGenerator.getInstance().generateId();

        this.addEventListener('added', this.onAddedToStage.bind(this));
        this.addEventListener('removed', this.onRemovedFromStage.bind(this));

        this._mainContainer = mainContainer;
    }

    public get updatedData(): FlyerPageSpotDto{
        console.log(`create update spot rectangle`);
        let bounds = this.getBounds();

        let data = this._data!;

        data.fpsPositionNo = Number.parseInt(this._label!.text);
        data.fpsX0px = this.x;
        data.fpsY0px = this.y;
        data.fpsWidthPx = bounds.width;
        data.fpsHeightPx = bounds.height;
        data.fpsIconXPct = this._frameIconData?.iconXPercentageNumber;
        data.fpsIconYPct = this._frameIconData?.iconYPercentageNumber;

        //
        data.hasNumber = this._hasNumber;

        return data;
    }

    public set initialData(value: FlyerPageSpotDto | null){
        console.log(`init spot rectangle`);
        this._data = value;

        if(this._data?.hasNumber) {
            this._hasNumber = true;
            this._label!.text = this._data.fpsPositionNo!.toString();
        }
    }

    public get initialData(){
        return this._data;
    }

    private onAddedToStage(event: any)
    {
        if (event.target.stage != null)
        {
            this.initIconsManagement()

            document.getElementsByClassName('canvas_container')[0].appendChild(this._input!);
        }
    }

    private initIconsManagement(){

        let golbalId = this._globalId

        let mouseTracker = this._mainContainer!.canvasMouseTracker!;

        // topLeftRectScaller
        mouseTracker.addMouseIcon(
            'topLeftRectScaller' + golbalId,
            top_left_to_bottom_right_scaller,
            this._selectedLayer!.topLeftRect,
            () => {
                mouseTracker.showMouseIcon('topLeftRectScaller' + golbalId);
            }
        )

        // bottomRightRectScaller
        mouseTracker.addMouseIcon(
            'bottomRightRectScaller' + golbalId,
            top_left_to_bottom_right_scaller,
            this._selectedLayer!.bottomRightRect,
            () => {
                mouseTracker.showMouseIcon('bottomRightRectScaller' + golbalId);
            }
        )

        // botomLeftRectScaller
        mouseTracker.addMouseIcon(
            'botomLeftRectScaller' + golbalId,
            bottom_left_to_top_right_scaller,
            this._selectedLayer!.bottomLeftRect,
            () => {
                mouseTracker.showMouseIcon('botomLeftRectScaller' + golbalId);
            }
        )

        // topRightRectScaller
        mouseTracker.addMouseIcon(
            'topRightRectScaller' + golbalId,
            bottom_left_to_top_right_scaller,
            this._selectedLayer!.topRightRect,
            () => {
                mouseTracker.showMouseIcon('topRightRectScaller' + golbalId);
            }
        )
    }

    private onRemovedFromStage(){
        try {
            document.getElementsByClassName('canvas_container')[0].removeChild(this._input!);
        }
        catch(e){

        }
    }

    public updateOriginalDImensions() {
        this._originalWidth = this._background!.getBounds().width;
        this._originalHeight = this._background!.getBounds().height;


        this.setBounds(0, 0, this._originalWidth, this._originalHeight);
    }

    init(spotIndex: number, dimensions: Dimensions, frameIconData?: FrameIconDataDto, isSelectedSpot?: boolean) {
        if(this._background) {
            return;
        }

        this._originalWidth = dimensions.width!;
        this._originalHeight = dimensions.height!;
        this._isSelected = isSelectedSpot ? isSelectedSpot : false
        this._background = new createjs.Shape();
        this.initBackground(
            "#18A0FB",
            "#FFFFFF44",
            this._originalWidth,
            this._originalHeight
        )
        this.addChild(this._background);
        if(frameIconData){
            this._frameIconData = frameIconData;
            const icon: string = this.getIconSrcUsingFrameType(frameIconData.type);
            this._frameIcon = new createjs.Bitmap(icon);
            let frameIcon = this._frameIcon;
            this._frameIcon.image.onload = function() {
                if(frameIcon.stage){
                    const frameSizesWxH = 32;
                    // frameIcon.scaleX = frameSizesWxH/frameIcon.image.width;
                    // frameIcon.scaleY = frameSizesWxH/frameIcon.image.height;
                    frameIcon.x = dimensions.width && frameIconData.iconXPercentageNumber && Number(frameIconData.iconXPercentageNumber) ? (dimensions.width / 100 * frameIconData.iconXPercentageNumber) - (frameSizesWxH/2) : (dimensions.width! / 100 * 50) - (frameSizesWxH/2);
                    frameIcon.y = dimensions.height && frameIconData.iconYPercentageNumber && Number(frameIconData.iconYPercentageNumber) ? (dimensions.height / 100 * frameIconData.iconYPercentageNumber) - (frameSizesWxH/2) : (dimensions.height! / 100 * 50) - (frameSizesWxH/2);
                    frameIcon.visible = true;
                    frameIcon.stage.update();
                }
            }
            // const frameSizesWxH = 32;
            // this._frameIcon.x = dimensions.width && frameIconData.iconXPercentageNumber && Number(frameIconData.iconXPercentageNumber) ? (dimensions.width / 100 * frameIconData.iconXPercentageNumber) - (frameSizesWxH / 2) : (dimensions.width! / 100 * 50) - (frameSizesWxH / 2);
            // this._frameIcon.y = dimensions.height && frameIconData.iconYPercentageNumber && Number(frameIconData.iconYPercentageNumber) ? (dimensions.height / 100 * frameIconData.iconYPercentageNumber) - (frameSizesWxH / 2) : (dimensions.height! / 100 * 50) - (frameSizesWxH / 2);
            this._frameIcon.visible = true;
            this.addChild(this._frameIcon);
            console.log(this._frameIcon.x);
        }

        this._label = new StrokedText(
            `${spotIndex}`,
            "bold 26px 'Roboto'",
            "#FFFFFF",
            "#262626"
        );

        this._label.mouseChildren = false;
        this._label.mouseEnabled = false;
        this.addChild(this._label);

        this.createHtmlInput(dimensions);

        this._selectedLayer = new SpotSelectedLayer();
        this.addChild(this._selectedLayer);
        this._selectedLayer.setVisible(false);

        //
        this._selectedLayer.topLeftRect.addEventListener('pressmove', (e: any) => {
            let mouseEvent = e as MouseEvent
            dispatchEventDataType(EVENT_DATA_TYPE_SPOT_DRAG_TOP_LEFT, {
                spot: this,
                mouseEvent: mouseEvent
            })
        })

        this._selectedLayer.topRightRect.addEventListener('pressmove', (e: any) => {
            let mouseEvent = e as MouseEvent
            dispatchEventDataType(EVENT_DATA_TYPE_SPOT_DRAG_TOP_RIGHT, {
                spot: this,
                mouseEvent: mouseEvent
            })
        })

        this._selectedLayer.bottomLeftRect.addEventListener('pressmove', (e: any) => {
            let mouseEvent = e as MouseEvent
            dispatchEventDataType(EVENT_DATA_TYPE_SPOT_DRAG_BOTTOM_LEFT, {
                spot: this,
                mouseEvent: mouseEvent
            })
        })

        this._selectedLayer.bottomRightRect.addEventListener('pressmove', (e: any) => {
            let mouseEvent = e as MouseEvent
            dispatchEventDataType(EVENT_DATA_TYPE_SPOT_DRAG_BOTTOM_RIGHT, {
                spot: this,
                mouseEvent: mouseEvent
            })
        })

        //
        this.addEventListener('pressmove', (e: any) => {

            if(!this.isSelected) {
                return;
            }

            let mouseEvent = e as MouseEvent
            dispatchEventDataType(EVENT_DATA_TYPE_SPOT_PRESS_MOVE, {
                spot: this,
                mouseEvent: mouseEvent
            })
        })

        //
        this.updateScale(1, 1);
        this.updateLabelPosition();
    }

    private createHtmlInput(dimensions: Dimensions){

        this._originalWidth = dimensions.width!;
        this._originalHeight = dimensions.height!;

        let inputWidth = this._originalWidth * 0.1;
        let inputHeight = this._originalHeight * 0.1;

        this._input = document.createElement('input')
        this._input.setAttribute('type', 'text');
        this._input.className = `canvas_spot_item_text_input`
        this._input.style.height = `${inputHeight}px`;
        this._input.style.width = `${inputWidth}px`;
        this._input.style.backgroundColor = '#00000000';
        this._input.style.color = "#262626";
        this._input.style.border = '1px solid white';
        this._input.style.fontFamily = 'Roboto'
        this._input.style.fontSize = '26px'
        this._input.style.fontWeight = 'bold'
        this._input.style.position = "absolute";
        this._input.style.textAlign = "center";
        this._input.style.top = '2px';
        this._input.style.left = '2px';
        this._input.oninput = this.handleOnInput.bind(this);
        document.getElementsByClassName('canvas_container')[0].appendChild(this._input);


        this._canvasInput = new createjs.DOMElement(this._input);
        // canvasInput.x = 20;
        // canvasInput.y = 20;
        this.addChild(this._canvasInput);
        this._canvasInput.visible = false;

        //
        //this._label?.addEventListener('click', this.onLabelClick.bind(this))
        this._input.addEventListener("keyup", this.onKeyUp.bind(this));
    }

    private handleOnInput(){
        let nextValue = this._input!.value.replace(/[^0-9]/g, '');
        if(nextValue === '0'){
            nextValue = '1'
        }
        else if(nextValue.length > 2){
            nextValue = this._input!.value.slice(0, 2);
        }
        this._input!.value = nextValue;
    }

    public showEditMode(value: boolean){
        if(value){
            this._label!.visible = false;
            this._canvasInput!.visible = true;
            this._input!.value = this._label!.text;
            setTimeout(() => {
                this._input!.focus();
            }, 0);
        }
        else {
            this._label!.visible = true;
            this._canvasInput!.visible = false;
        }

        this.stage.update();
    }

    private onKeyUp (event: KeyboardEvent) {
        // Number 13 is the "Enter" key on the keyboard
        if (event.keyCode === 13)
        {
            event.preventDefault();

            let newPositionNumber = this._input!.value;
            let alreadyExist = this._mainContainer!.spotsFunctions!.hasPositionNumberAlreadyExist(this, Number.parseInt(newPositionNumber))
            if(alreadyExist) {
                this._input!.value = '' //this._data!.fpsPositionNo!.toString();
                this.stage.update();
                alert(`number of ${newPositionNumber} already exist, please enter different number`)
                return;
            }

            this.showEditMode(false);


            if(newPositionNumber === '') {
                // set old value
                newPositionNumber = this._data!.fpsPositionNo!.toString();
                // no need to save anything
                return;
            }

            //
            this._label!.text = newPositionNumber;

            //
            this._data!.fpsPositionNo = Number.parseInt(newPositionNumber);
            let updatedData = this.updatedData
            this._mainContainer?.persistenceManager?.prepareSpotsForSaving([updatedData])

            // 
            this.setSelected(true)

            this.stage.update();
        }
    }

    public set text(value: string){
        this._label!.text = value;

        this.updateLabelPosition();
    }

    public get text(){
        return this._label!.text;
    }

    public get isSelected(){
        return this._isSelected;
    }

    private initBackground(strokeColor: string, fillColor: string, width: number, height: number){
        this._background!.graphics
            .setStrokeStyle(3)
            .beginStroke(strokeColor)
            .beginFill(fillColor)
            .drawRect(0, 0, width, height)
            .endFill();

        // need to set setBounds otherwise getBounds will return null
        this._background!.setBounds(0, 0, width, height);
    }

    public showLabel(value: boolean){
        this._label!.visible = value;

        if(value){
            this._hasNumber = true;
        }
    }
    public showIcon(value: boolean){
        this._frameIcon!.visible = value;
    }

    public getIconSrcUsingFrameType(frameType: number | null){
        const frameIcons = this._mainContainer?._framesIcons || null;
        let icon: string;
        switch (frameType) {
            case 2:
                icon = frameIcons && frameIcons.iconStyleType !== 2 && frameIcons.iconStyleType !== 3 ? frameIcons.iconStyleData.pageCompSrc : promoJumpToPageIcon;
                break;
            case 3:
                icon = frameIcons && frameIcons.iconStyleType !== 2 && frameIcons.iconStyleType !== 3 ? frameIcons.iconStyleData.linkCompSrc : promoJumpToUrlIcon;
                break;
            case 4:
                icon = frameIcons && frameIcons.iconStyleType !== 2 && frameIcons.iconStyleType !== 3 ? frameIcons.iconStyleData.videoCompSrc : promoPlayVideoIcon;
                break;
            case 5:
                icon = frameIcons && frameIcons.iconStyleType !== 2 && frameIcons.iconStyleType !== 3 ? frameIcons.iconStyleData.imgCompSrc : promoImageIcon;
                break;
            case 6:
                icon = frameIcons && frameIcons.iconStyleType !== 2 && frameIcons.iconStyleType !== 3 ? frameIcons.iconStyleData.img360CompSrc : promoImage360Icon;
                break;
            default:
                icon = frameIcons && frameIcons.iconStyleType !== 2 && frameIcons.iconStyleType !== 3 ? frameIcons.iconStyleData.promoCompSrc : promoIcon;
                break
        }
        return icon;
    }

    public updateFrameIconImage(frameType: number) {
        const frameIconSrc = this.getIconSrcUsingFrameType(frameType);
        const image = new Image();
        image.src = frameIconSrc;
        const frameIcon = this._frameIcon!;
        frameIcon.image = image;
        frameIcon.image.onload = function() {
            if(frameIcon.stage){
                frameIcon.stage.update();
            }
        }
    }

    setPosition(x: number, y: number) {
        this._originalX = x;
        this._originalY = y;
    }

    public updateScale(scaleX: number, scaleY: number) {
        // look this
        this._background!.graphics.clear()

        if(this._isSelected) {
            this.initBackground(
                "#18A0FB",
                "rgba(240, 202, 33, 0.4)",
                this._originalWidth * scaleX,
                this._originalHeight * scaleY
            )
        }
        else {
            this.initBackground(
                "#18A0FB",
                "#FFFFFF44",
                this._originalWidth * scaleX,
                this._originalHeight * scaleY
            )
        }
        // need to set setBounds otherwise getBounds will return null
        this._background!.setBounds(0, 0, this._originalWidth * scaleX, this._originalHeight * scaleY)
        //
        this.updateLabelPosition();
        this.updateIconPosition();
        let minimalSpotDimensions = this._mainContainer!.spotsFunctions!.getMinimalSpotDimensions()
        let inputWidth =  Math.floor(this._label!.getBounds().width);
        let inputHeight = Math.floor(this._label!.getBounds().height);
        // let inputWidth =  minimalSpotDimensions.width!
        // let inputHeight = minimalSpotDimensions.height!
        this._input!.style.height = `${inputHeight}px`;
        this._input!.style.width = `${inputWidth}px`;
        this._input!.style.left = this._label?.x! + 'px';
        this._input!.style.top = this._label?.y! + 'px';
        // this._input!.style.left = (this._originalWidth * scaleX - inputWidth) * 0.5 + 'px';
        // this._input!.style.top = (this._originalHeight * scaleY - inputHeight) * 0.5 + 'px';
        const {iconYPercentageNumber, iconXPercentageNumber} = this._frameIconData!;
        const iconWidth = 32;
        if(iconYPercentageNumber && iconXPercentageNumber){
            if((iconYPercentageNumber >= 40 && iconYPercentageNumber <= 60 && iconXPercentageNumber >= 40 && iconXPercentageNumber <= 60)){
                if(this._originalWidth * scaleX >= 90 && this._originalHeight * scaleY <= 90){
                    if(iconXPercentageNumber <= 50){
                        this._input!.style.left = this._label?.x! + iconWidth + 'px';
                    } else {
                        this._input!.style.left = this._label?.x! - iconWidth + 'px';
                    }

                    // this._input!.style.left = (this._originalHeight * scaleY - inputHeight) * 0.5 + 35 + 'px';
                }
                else if(this._originalWidth * scaleX <= 90 && this._originalHeight * scaleY >= 90){
                    if(iconYPercentageNumber <= 50){
                        this._input!.style.top = this._label?.y! + iconWidth + 'px';
                    } else {
                        this._input!.style.top = this._label?.y! - iconWidth + 'px';
                    }

                    // this._input!.style.left = (this._originalHeight * scaleY - inputHeight) * 0.5 - 35 + 'px';
                }
                else if(this._originalWidth * scaleX > 90 && this._originalHeight * scaleY > 90){
                    if(iconYPercentageNumber >= 50){
                        this._input!.style.top = this._label?.y! - iconWidth + 'px';
                    } else {
                        this._input!.style.top = this._label?.y! + iconWidth + 'px';
                    }

                    // if(iconXPercentageNumber > 50){
                    //     this._input!.style.left = this._label?.x! - 35 + 'px';
                    // } else {
                    //     this._input!.style.left = this._label?.x! + 35 + 'px';
                    // }

                    // this._input!.style.left = (this._originalHeight * scaleY - inputHeight) * 0.5 - 35 + 'px';
                }
                // else {
                //     this._input!.style.top = this._label?.y! + 35 + 'px';
                //     // this._input!.style.top = (this._originalHeight * scaleY - inputHeight) * 0.5 + 35 + 'px';
                // }
            }
        }

        //
        this._selectedLayer!.updatePosition(this._background!.getBounds().width, this._background!.getBounds().height)

        // important to update Bounds otherwise the getBounds() will return wrong values
        this.setBounds(0, 0, this._originalWidth * scaleX, this._originalHeight * scaleY);
        //look this
    }

    public updateLabelPosition(data?: FrameIconDataDto){
        let backgroundBounds = this._background!.getBounds();
        let labelBounds = this._label!.getBounds();
        this._label!.x = backgroundBounds.width * 0.5  - labelBounds.width * 0.5;
        this._label!.y = backgroundBounds.height * 0.5 - labelBounds.height * 0.5;
        this._frameIcon!.alpha = 1;
        const iconSize = 32 + 4;
        const {iconYPercentageNumber, iconXPercentageNumber} = data ? data : this._frameIconData!;
        if(iconYPercentageNumber && iconXPercentageNumber){
            if((iconYPercentageNumber >= 40 && iconYPercentageNumber <= 60 && iconXPercentageNumber >= 40 && iconXPercentageNumber <= 60)){
                if(backgroundBounds.width >= 90 && backgroundBounds.height <= 90){
                    if(iconXPercentageNumber <= 50){
                        this._label!.x = this._label!.x + iconSize;
                    } else {
                        this._label!.x = this._label!.x - iconSize;
                    }
                    // this._input!.style.left = (this._originalHeight * scaleY - inputHeight) * 0.5 + 35 + 'px';
                }
                else if(backgroundBounds.width <= 90 && backgroundBounds.height >= 90){
                    if(iconYPercentageNumber <= 50){
                        this._label!.y = this._label?.y! + iconSize;
                    } else {
                        this._label!.y = this._label?.y! - iconSize;
                    }

                    // this._input!.style.left = (this._originalHeight * scaleY - inputHeight) * 0.5 - 35 + 'px';
                }
                else if(backgroundBounds.width > 90 && backgroundBounds.height > 90){
                    if(iconYPercentageNumber > 50){
                        this._label!.y = this._label!.y - iconSize;
                    } else {
                        this._label!.y = this._label!.y + iconSize;
                    }
                    // if(iconXPercentageNumber >= 50){
                    //     this._label!.x = this._label!.x - 36;
                    // } else {
                    //     this._label!.x = this._label!.x + 36;
                    // }
                }

                // else if(backgroundBounds.width > 60 && backgroundBounds.height > 50 ){
                //     this._label!.x = this._label!.x + 36;
                //     // this._input!.style.left = (this._originalHeight * scaleY - inputHeight) * 0.5 - 35 + 'px';
                // }
                // else {
                //     this._label!.y = this._label!.y + 36;
                // }

            }
        }

        if(backgroundBounds.width <= 90 && backgroundBounds.height <= 90){
            this._frameIcon!.alpha = 0.5;
        }
    }

    public updateIconPosition(data?: FrameIconDataDto){
        if(this._frameIcon && this._frameIcon!.getBounds()){
            let backgroundBounds = this._background!.getBounds();
            const iconSize = 32;
            const {iconYPercentageNumber, iconXPercentageNumber} = data ? data : this._frameIconData!;
            if(iconYPercentageNumber && iconXPercentageNumber){
                this._frameIcon.x = backgroundBounds.width && iconXPercentageNumber && Number(iconXPercentageNumber) ? (backgroundBounds.width / 100 * iconXPercentageNumber) - (iconSize / 2) : (backgroundBounds.width! / 100 * 50) - (iconSize / 2);
                this._frameIcon.y = backgroundBounds.height && iconYPercentageNumber && Number(iconYPercentageNumber) ? (backgroundBounds.height / 100 * iconYPercentageNumber) - (iconSize / 2) : (backgroundBounds.height! / 100 * 50) - (iconSize / 2);
            }

        }
    }

    public updatePositionByScale(scaleX: number, scaleY: number) {
        this.x = this._originalX * scaleX
        this.y = this._originalY * scaleY
    }

    public setSelected(value: boolean, isDisabledZoom: boolean = true){
        this._isSelected = value;
        let bgBounds = this._background!.getBounds();
        if(isDisabledZoom){
            this._selectedLayer!.setVisible(value);
        }

        if(this._isSelected) {

            this._background!.graphics.clear();

            this.initBackground(
                "#18A0FB",
                "rgba(240, 202, 33, 0.4)",
                bgBounds.width,
                bgBounds.height
            )

            this._selectedLayer!.updatePosition(bgBounds.width, bgBounds.height);

        }
        else {
            this._background!.graphics.clear();

            this.initBackground(
                "#18A0FB",
                "#FFFFFF44",
                bgBounds.width,
                bgBounds.height
            )

            this._background!.setBounds(0, 0, bgBounds.width, bgBounds.height);
        }

    }

    public getBoundaries(): Boundries {
        let dto: Boundries = new Boundries()
        dto.init(
            this.x,
            this.x + this.getBounds().width,
            this.y,
            this.y + this.getBounds().height
        )
        return dto;
    }

    public dispose(){

        try {
            document.getElementsByClassName('canvas_container')[0].removeChild(this._input!)
        }
        catch(e){

        }

        this.removeEventListener('added', this.onAddedToStage.bind(this));
        this.removeEventListener('removed', this.onRemovedFromStage.bind(this));

        this._input!.removeEventListener("keyup", this.onKeyUp.bind(this));

        this.removeAllEventListeners();

        this._mainContainer = null;
    }


    public get originalHeight(): number {
        return this._originalHeight;
    }
    public get originalWidth(): number {
        return this._originalWidth;
    }

    public get hasNumber(): boolean {
        return this._hasNumber;
    }
}

export class SpotModelViewDto {
    dto?: FlyerPageSpotDto;
    spot?: Spot;
}